import { useLanguage } from '@/i18n/LanguageContext';

export default function LanguageSwitcher({ className = '' }) {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg bg-zinc-800/50 hover:bg-zinc-700/50 transition-colors text-sm font-medium ${className}`}
      data-testid="language-switcher"
    >
      <span className={`${language === 'en' ? 'text-white' : 'text-zinc-500'}`}>EN</span>
      <span className="text-zinc-600">/</span>
      <span className={`${language === 'el' ? 'text-white' : 'text-zinc-500'}`}>ΕΛ</span>
    </button>
  );
}
